import useBotsService from '../../../../../services/bot/botService'
import classes from './SessionItem.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { toggle } from '../../sidebarSlice'
import Tooltip from '@mui/material/Tooltip';

function SessionItem(props) {
    const botService = useBotsService()
    const isMobile = useSelector(state => state.layout).isMobile
    const dispatch = useDispatch()    

    let className = "SessionItem"
    if (props.selected) {
        className = "SessionItemSelected"
    }

    const select = async () => {
        await botService.switchSession(props.id)
        if (isMobile) {
            dispatch(toggle({isOpen: false}))
        }
    }

    const format = (dt) => {
        const date = String(dt).split("T")[0].split("-")
        const dateString = `${removePrefixZero(date[2])}.${removePrefixZero(date[1])}.${removePrefixZero(date[0])}`
        const time = String(dt).split("T")[1].split(":")
        const timestring = `${time[0]}:${time[1]}`
        return `${dateString} | ${timestring} `
    }

    const formatName = (name) => {
        if (!name) return ""
        let maxLength = 20
        if (window.innerWidth < 480) {
            maxLength = 40
        }
        console.log(name)
        if (name.length <= maxLength) {
            return name
        }
        return name.substring(0,maxLength-4) + " ..."
    }

    const removePrefixZero = (str) => {
        if (str.startsWith("0")) {
            return str.replace("0","")
        } else {
            return str
        }
    }

    return (
        <Tooltip title={props.name}>
            <div className={classes[className]} onClick={select}>
                <div className={classes.SessionItemDate}>{format(props.lastUpdated)}</div>
                <div className={classes.SessionItemName}>{formatName(props.name)}</div>
            </div>
        </Tooltip>
    );
}

export default SessionItem;
